// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0b4fbc3","239":"34f01fa7","453":"413d604e","667":"1a02debc"}[chunkId] + ".chunk.js";
};